<template>

    <div class="header">
        <a :href="url" class="logo">
            <img src="/img/crowdpower-logo.svg" height="30" width="auto" title="CrowdPower" />
        </a>
    </div>

</template>

<style scoped lang="scss">

    .header {
        display: flex;
        justify-content: center;
        padding: 30px 15px;
        .logo {
            align-items: center;
            display: flex;
            text-decoration: none;
            transition: opacity .3s;
            &:hover {
                opacity: 0.7;
            }
        }
    }

</style>

<script>

export default {

    data() {
        return {
            url: process.env.VUE_APP_URL,
        }
    },

}

</script>
